import * as React from 'react';
import {getLanguage, setLanguage} from '../../Util/language';
import '../../style/enquiry.css';

interface SwitchLanguageState {
    selected: string
}

class SwitchLanguage extends React.Component <{}, SwitchLanguageState> {
    public constructor(props) {
        super(props);
        this.state = {
            selected: "en"
        }
        this.changeLang = this.changeLang.bind(this);
        this.getClassName = this.getClassName.bind(this);
    }

    public componentDidMount() {
        this.setState({
            selected: getLanguage()
        });
    }

    public changeLang(lang) {
        setLanguage(lang);
        this.setState({
            selected: getLanguage()
        });
    }

    public getClassName(target) {
        const active = this.state.selected === target ? "active" : "";
        return `lang-option ${active}`
    }

    public render() {
        return (
            <div className="lang-selector">
                <div className={this.getClassName("en")} onClick={() => this.changeLang("en")}>EN</div>
                <span className="separator"/>
                <div className={this.getClassName("zh-hk")} onClick={() => this.changeLang("zh-hk")}>中文</div>
            </div>
        );
    }
}

export default SwitchLanguage;


// WEBPACK FOOTER //
// ./src/Components/Translator/SwitchLanguage.tsx